import React from 'react';
import { ColorsType, SizesType, variables, WeightType } from '../../components/variables';
import styled from 'styled-components';

const Styles = styled.span<Partial<TextProps>>`
    &&& {
        display: inline-flex;
        font-size: ${(props: Partial<TextProps>) => variables.sizes[props.size ?? '12']};
        color: ${(props: Partial<TextProps>) => variables.colors[props.color ?? 'road-grey']};
        font-weight: ${(props: Partial<TextProps>) => variables.weight[props.weight ?? '400']};
        line-height: 1.4;
    }
`;

type ExtraPropsType = {
    as?: 'span' | 'div' | 'a' | 'button';
    href?: string;
    onClick?: (e: any) => void;
};

export type TextProps = {
    size?: SizesType;
    color?: ColorsType;
    weight?: WeightType;
    children: React.ReactNode;
    className?: string;
    extraProps?: ExtraPropsType;
};

export const Text: React.FC<TextProps> = ({
    size = '12',
    color = 'road-grey',
    weight = '400',
    children,
    extraProps,
    className = 'text',
}: TextProps) => {
    return (
        <Styles size={size} color={color} weight={weight} className={className} {...extraProps}>
            {children}
        </Styles>
    );
};
